export default "__VITE_ASSET__CLeWLtkl__"